import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Settings from "components/dashboard/Settings";
import ZipSlotAdsGate from "components/common/ZipSlotAdsGate";
import ZipSlotBiddingPage from "pages/dashboard/zipSlotAds/ZipSlotBiddingPage";
import AdBalancePage from "pages/dashboard/zipSlotAds/AdBalancePage";
import AdPerformancePage from "pages/dashboard/zipSlotAds/AdPerformancePage";
import DashboardLayout from "components/dashboard/DashboardLayout";
import { useAuth } from "hooks/useAuth";

/**
 * Dedicated dashboard for users.role === marketingExecutive.
 * Advertising pages only — no TCI, clinical, or hierarchy-node surfaces.
 */
const MarketingExecutiveRoutes = () => {
  const { user, subscription } = useAuth();

  return (
    <DashboardLayout>
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/dashboard/advertising/slots" replace />}
        />
        <Route
          path="/advertising/slots"
          element={
            <ZipSlotAdsGate>
              <ZipSlotBiddingPage />
            </ZipSlotAdsGate>
          }
        />
        <Route
          path="/advertising/balance"
          element={
            <ZipSlotAdsGate>
              <AdBalancePage />
            </ZipSlotAdsGate>
          }
        />
        <Route
          path="/advertising/performance"
          element={
            <ZipSlotAdsGate>
              <AdPerformancePage />
            </ZipSlotAdsGate>
          }
        />
        <Route
          path="/settings"
          element={<Settings uid={user?.uid} subscription={subscription} />}
        />
        <Route
          path="*"
          element={<Navigate to="/dashboard/advertising/slots" replace />}
        />
      </Routes>
    </DashboardLayout>
  );
};

export default MarketingExecutiveRoutes;
